'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  padding: 0.5rem 1rem;\n  color: white;\n  border: 5px solid #8E1600;\n  border-radius: 5px;\n  background-color: #B53737;\n\n  .fa {\n    margin-right: 0.5rem;\n  }\n'], ['\n  padding: 0.5rem 1rem;\n  color: white;\n  border: 5px solid #8E1600;\n  border-radius: 5px;\n  background-color: #B53737;\n\n  .fa {\n    margin-right: 0.5rem;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  padding-top: 0.5rem;\n\n  @media (max-width: 500px) {\n    flex-direction: column;\n  }\n\n  button {\n    color: #white;\n    background-color: transparent;\n    border-color: #333;\n    padding: .2rem 0.6rem;\n    margin: 0.25rem;\n    font-size: 0.9rem;\n    font-weight: 400;\n    line-height: 1.5;\n    text-align: center;\n    white-space: wrap;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    border: 1px solid #333;\n    border-radius: .25rem;\n\n    &:hover {\n      background-color: #333;\n      color: rgba(255, 255, 255, 0.8) !important;\n    }\n  }\n\n  input {\n    line-height: 1.5;\n    font-size: 1.1rem;\n    font-weight: 400;\n    @media (max-width: 500px) {\n      width: 100%;\n    }\n  }\n\n'], ['\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  padding-top: 0.5rem;\n\n  @media (max-width: 500px) {\n    flex-direction: column;\n  }\n\n  button {\n    color: #white;\n    background-color: transparent;\n    border-color: #333;\n    padding: .2rem 0.6rem;\n    margin: 0.25rem;\n    font-size: 0.9rem;\n    font-weight: 400;\n    line-height: 1.5;\n    text-align: center;\n    white-space: wrap;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    border: 1px solid #333;\n    border-radius: .25rem;\n\n    &:hover {\n      background-color: #333;\n      color: rgba(255, 255, 255, 0.8) !important;\n    }\n  }\n\n  input {\n    line-height: 1.5;\n    font-size: 1.1rem;\n    font-weight: 400;\n    @media (max-width: 500px) {\n      width: 100%;\n    }\n  }\n\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactFontawesome = require('react-fontawesome');

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Panel = _styledComponents2.default.div(_templateObject);

var Center = _styledComponents2.default.div(_templateObject2);
/** @class AnonymousConversion
  * A component to encourage a user to create an account.
  */

var AnonymousConversion = function (_Component) {
  _inherits(AnonymousConversion, _Component);

  /** @constructor
    * Creates a new instance of the component
    */
  function AnonymousConversion(props) {
    _classCallCheck(this, AnonymousConversion);

    var _this = _possibleConstructorReturn(this, (AnonymousConversion.__proto__ || Object.getPrototypeOf(AnonymousConversion)).call(this, props));

    _this.state = { email: '' };
    _this.handleChange = _this.handleChange.bind(_this);
    _this.sendSignInLinkToEmail = _this.sendSignInLinkToEmail.bind(_this);
    _this.sendSignInLinkToNewUser = _this.sendSignInLinkToNewUser.bind(_this);
    _this.sendSigninLinkToAnonUser = _this.sendSigninLinkToAnonUser.bind(_this);
    return _this;
  }
  /** @method handleChange
    * Handles input events
    * @param {event} event - the input event
    */


  _createClass(AnonymousConversion, [{
    key: 'handleChange',
    value: function handleChange(event) {
      var target = event.target;
      var value = target.value;
      var name = target.name;
      this.setState(_defineProperty({}, name, value));
    }
    /** @method sendSignInLinkToEmail
      * Sends the email link to the user's supplied email, using an
      * appropriate method
      */

  }, {
    key: 'sendSignInLinkToEmail',
    value: function sendSignInLinkToEmail() {
      if (window.vexpo && window.vexpo.firebase && window.vexpo.firebase.auth().currentUser) this.sendSigninLinkToAnonUser();else this.sendSignInLinkToNewUser();
    }
    /** @method sendSigninLinkToNewUser
      * Sends a signin link to a user without an account
      */

  }, {
    key: 'sendSignInLinkToNewUser',
    value: function sendSignInLinkToNewUser() {
      var _this2 = this;

      if (window.vexpo && window.vexpo.firebase) {
        // Send the user a login link
        var actionCodeSettings = {
          url: window.location.protocol + '//' + window.location.host + '/#/lobby',
          handleCodeInApp: true
        };
        window.vexpo.firebase.auth().sendSignInLinkToEmail(this.state.email, actionCodeSettings).then(function () {
          window.localStorage.setItem('emailForSignIn', _this2.state.email);
          window.alert("Email sent.  Check your inbox for your personalized link.");
        }).catch(function (error) {
          if (error.code === 'auth/invalid-email') window.alert('That does not appear to be a valid email address.  Please try again.');else window.alert("We are sorry, there was an error sending your personalized link.");
        });
      }
    }
    /** @method sendSignInLinkToAnonUser
      * Converts an anonomous user into a regsitered one
      * and sends them a signin link.
      */

  }, {
    key: 'sendSigninLinkToAnonUser',
    value: function sendSigninLinkToAnonUser() {
      var _this3 = this;

      var registerShowbag = window.vexpo.firebase.functions().httpsCallable('registerShowbag');
      registerShowbag(this.state.email).then(function (result) {
        return console.log(result);
      }).then(function () {
        if (window.vexpo && window.vexpo.firebase) {
          // Send the user a login link
          var actionCodeSettings = {
            url: window.location.protocol + '//' + window.location.host + '/#/lobby',
            handleCodeInApp: true
          };
          window.vexpo.firebase.auth().sendSignInLinkToEmail(_this3.state.email, actionCodeSettings).then(function () {
            window.localStorage.setItem('emailForSignIn', _this3.state.email);
            window.alert("Email sent.  Check your inbox for your personalized link.");
          }).catch(function (error) {
            if (error.code === 'auth/invalid-email') window.alert('That does not appear to be a valid email address.  Please try again.');else window.alert("We are sorry, there was an error sending your personalized link.");
          });
        }
      });
    }
    /** @method render
      * Renders the component
      */

  }, {
    key: 'render',
    value: function render() {
      var user = window.vexpo.firebase.auth().currentUser;
      if (!user || user.isAnonymous) {
        return _react2.default.createElement(
          Panel,
          null,
          _react2.default.createElement(
            'h3',
            null,
            _react2.default.createElement(_reactFontawesome2.default, { name: 'exclamation-triangle' }),
            'Your Personal My Favorites List is not Saved!'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Saving items you may want to purchase to a personal My Favorites list is fun and saves shopping time. To activate a personal My Favorites list enter your email address below and we\u2019ll send you a link that will bring you back to the show with your Personal My Favorites list. We do not share your email with any third party.'
          ),
          _react2.default.createElement(
            Center,
            null,
            _react2.default.createElement('input', {
              type: 'email',
              name: 'email',
              placeholder: 'your email address',
              value: this.state.email,
              onChange: this.handleChange
            }),
            _react2.default.createElement(
              'button',
              { onClick: this.sendSignInLinkToEmail },
              _react2.default.createElement(_reactFontawesome2.default, { name: 'envelope' }),
              'Send Me a Personalized Link'
            )
          )
        );
      } else {
        return '';
      }
    }
  }]);

  return AnonymousConversion;
}(_react.Component);

exports.default = AnonymousConversion;


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/showbag/anonymous-conversion.js
// module id = 240
// module chunks = 0